// pipelines-list-sort-and-narrow — the shared vocabulary of the Pipelines list's narrowing
// state. Everything here is a value that must mean the SAME thing in three places at once: the
// cell that renders it, the facet that offers it, and the URL that carries it. Hence one module,
// not three local constants that can drift apart.

// deploy-pipelines-list-payload OQ-5/AC-11, and now AC-6/AC-11 of this slice.
//
// HOISTED from PipelineTable.js (where it was a file-local const) because it stopped being a
// presentation detail the moment `(deleted)` became a FIRST-CLASS FACET VALUE: the App Instance
// column renders it, the facet offers it as a selectable option, and the URL serialises it. If
// those three ever disagreed, a reader could select `(deleted)` and get nothing back. One
// definition makes that class of bug unrepresentable.
export const DELETED_APP_INSTANCE_MARKER = '(deleted)';

// AC-12 — the never-run bucket as a SELECTABLE status value.
//
// A row's never-run-ness is `LatestRunStatus == null` on the wire, and `null` cannot be a URL
// param value or a distinct MUI option key without being confused with "no selection". So the
// UI/URL layer names it explicitly. It is deliberately a STRING, so it can never collide with a
// PipelineRunStatus numeric member — including a seventh one added later.
export const NEVER_RUN_STATUS_VALUE = 'never';

// AC-16 — the URL param names. Short, because they end up in a link a publisher pastes to a
// colleague, and stable, because a bookmark that stops working is worse than no bookmark.
//
// APP_INSTANCE and STATUS are REPEATED params (?appInstance=A&appInstance=B) rather than one
// comma-joined value. That is not a style choice: App Instance names are free text and may
// legitimately contain a comma, so any delimiter would need escaping, and an unescaped delimiter
// would silently split one real name into two facet values that match nothing.
export const PIPELINE_LIST_URL_PARAMS = {
	SEARCH: 'q',
	APP_INSTANCE: 'appInstance',
	STATUS: 'status',
	SORT_FIELD: 'sort',
	SORT_DIRECTION: 'dir'
};

// AC-4 — the five sortable fields, as an allow-list.
//
// An allow-list, not a deny-list, because this is also what the URL parser validates against
// (AC-16: a hand-edited `?sort=DROP TABLE` must be IGNORED, never thrown and never handed to the
// grid as a field it has no column for).
export const SORTABLE_PIPELINE_FIELDS = ['Name', 'AppInstanceName', 'ImageName', 'ContainerAppName', 'LatestRunStatus'];

export const SORT_DIRECTIONS = ['asc', 'desc'];
